import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import FormSchema from "./form-schemas";
import { Formik, Field, ErrorMessage } from "formik";
import { Form as FormFormik } from "formik";
import InputMask from "react-input-mask";
import { Button, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";
import pagarme from "pagarme/browser";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";

import { useUserData } from "../../hooks/UserContext";
import { BsCreditCard2Front } from "react-icons/bs";
import "./styles.css";
import { StyledTitle, Text, CheckboxLabel, CardBorder } from './styles';
import { configApiBasic } from "page/OrderResumePag/_services/api";
import  useDebounce  from "../../hooks/useDebounce";
import { useApp } from "../../contexts/AppContext";
import { useFeatureFlag } from "../../contexts/FeatureFlagProvider";

export const FormNewCard = ({
  saveNewCard,
  onCancel,
  cards,
  isMyAccountPage,
  Loading,
}) => {
  const { user, mainCard, setMainCard } = useUserData();
  const [cardValidationError, setCardValidationError] = useState("");
  const [isValidatingCard, setIsValidatingCard] = useState(false);
  const { whitelabel } = useApp();
  const screenName = useScreenTracking();
  const binValidationEnabled = useFeatureFlag("bin_validation");

  const cpf = user.cpf;

  function handleSelectMainCard() {
    onCancel();
  }

  async function validateBin(bin) {
    try {
      const response = await configApiBasic.post('/bins/validate', {
        channel: process.env.REACT_APP_DEFAULT_CHANNEL,
        cardNumber: bin
      });

      return response.data.success;
    } catch (error) {
      console.error('Error validating BIN:', error);
      throw error;
    }
  }

  const validateCardNumber = async (cardNumber, formValues) => {
    if (!cardNumber || cardNumber.replace(/\s/g, '').length < 6) {
      setCardValidationError("");
      return;
    }

    setIsValidatingCard(true);
    setCardValidationError("");

    try {
      const card_pagarme = {
        card_number: cardNumber,
        card_holder_name: formValues.card_holder_name || "",
        card_expiration_date: formValues.card_expiration_date || "",
        card_cvv: formValues.card_cvv || "",
      };

      const cardValidations = pagarme.validate({ card: card_pagarme });
      
      if (!cardValidations.card.card_number) {
        setCardValidationError("Cartão inválido");
        setIsValidatingCard(false);
        return;
      }

      const cleanCardNumber = cardNumber.replace(/\s/g, '');
      
      try {
        if (binValidationEnabled) {
          const binValidation = await validateBin(cleanCardNumber);
          if (!binValidation) {
            setCardValidationError("Utilize o seu cartão de crédito Safra.");
            return;
          }
        }
        setCardValidationError("");
      } catch (binError) {
        setCardValidationError("Erro ao validar o cartão.");
      }
    } catch (error) {
      setCardValidationError("Erro ao validar o cartão.");
    } finally {
      setIsValidatingCard(false);
    }
  };

  const debouncedValidateCard = useDebounce((cardNumber, formValues) => {
    validateCardNumber(cardNumber, formValues);
  }, 500, setIsValidatingCard);
 
  return (
    <>
      {cards.length > 0 && !isMyAccountPage && (
        <>
          <div className="mx-4">
            <StyledTitle className="font-wl-500 text-mlg">
              Selecione o cartão
            </StyledTitle>
          </div>

          <div className="w-full d-flex flex-column gap-3 mb-4">
            {cards &&
              cards.map((card, index) => (
                <CardBorder
                  key={index}
                  className="d-flex align-items-center justify-content-between pb-3"
                >
                  <Text className="font-wl-700 m-0">
                    {card.brand} - {card.last_four_digits}
                  </Text>
                  <input
                    type="radio"
                    name="mainCard"
                    value={card.uuid}
                    checked={mainCard && card.uuid === mainCard.uuid}
                    onChange={() => setMainCard(card)}
                  />
                </CardBorder>
              ))}
          </div>

          <div className="d-flex justify-content-center my-4">
            <button
              type="button"
              className="btn-default-wl font-wl-700 text-xxs p-2"
              style={{ width: 187 }}
              onClick={handleSelectMainCard}
            >
              SELECIONAR CARTÃO
            </button>
          </div>

          <div className="d-flex align-items-center justify-content-center gap-2">
            <div
              style={{ borderBottom: `1px solid ${whitelabel?.theme?.text_primary_color}`, width: "100%" }}
            />
            <Text className="font-wl-700">ou</Text>
            <div
              style={{ borderBottom: `1px solid ${whitelabel?.theme?.text_primary_color}`, width: "100%" }}
            />
          </div>
        </>
      )}
      <Formik
        onSubmit={(values, { setSubmitting }) => {
          const save = saveNewCard(values);
          if (save) {
            setSubmitting(false);
            //setIsLoading(true);
          } else {
            setSubmitting(false);
            //setIsLoading(true);
            return false;
          }
          setSubmitting(false);
          //setIsLoading(true);
        }}
        validationSchema={FormSchema}
        initialValues={{
          card_holder_name: "",
          card_document: cpf,
          card_number: "",
          card_expiration_date: "",
          card_cvv: "",
          card_save: false,
        }}
        enableReinitialize={false}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          isValid,
          dirty,
          setFieldValue,
        }) => (
          <FormFormik className="mb-4" onSubmit={handleSubmit}>
            <div className="mx-4">
              {cards.length && !isMyAccountPage > 0 ? (
                <StyledTitle className="font-wl-500 text-mlg">
                  Cadastre um novo cartão
                </StyledTitle>
              ) : (
                <StyledTitle className="font-wl-500 text-mlg">
                  Preencha os dados para <br /> adicionar seu cartão
                </StyledTitle>
              )}
            </div>
            <Form.Group className="mb-3">
              <span className="form-label mb-1">Número do Cartão</span>
              <InputMask
                mask="9999 9999 9999 9999"
                maskChar={null}
                className="form-control"
                name="card_number"
                onChange={(e) => {
                  handleChange(e);
                  debouncedValidateCard(e.target.value, values);
                }}
                onBlur={handleBlur}
                value={values.card_number}
              >
                {(inputProps) => (
                  <TextField
                    {...inputProps}
                    variant="standard"
                    type="tel"
                    error={!!cardValidationError}
                    InputProps={{
                      endAdornment: <BsCreditCard2Front />,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      autoComplete: "cc-csc",
                    }}
                    sx={{
                      '& .MuiInput-underline:before': {
                        borderBottomColor: cardValidationError ? 'var(--danger)' : whitelabel?.theme?.text_primary_color,
                      },
                      '& .MuiInput-underline:after': {
                        borderBottomColor: cardValidationError ? 'var(--danger)' : whitelabel?.theme?.text_primary_color,
                      },
                      '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                        borderBottomColor: cardValidationError ? 'var(--danger)' : whitelabel?.theme?.text_primary_color,
                      },
                      '& .MuiInputBase-input': {
                        color: cardValidationError ? 'var(--danger)' : whitelabel?.theme?.text_primary_color,
                      },
                      '& .MuiInputAdornment-root svg': {
                        color: cardValidationError ? 'var(--danger)' : whitelabel?.theme?.text_primary_color,
                      }
                    }}
                  />
                )}
              </InputMask>
              {cardValidationError && (
                <span className="text-danger text-sm">
                  {cardValidationError}
                </span>
              )}
              {!cardValidationError && (
                <ErrorMessage
                  className="text-danger text-sm"
                  component="span"
                  name="card_number"
                />
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <span className="form-label mb-1">Nome do titular do Cartão</span>
              <TextField
                className="form-control"
                name="card_holder_name"
                variant="standard"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.card_holder_name}
                  sx={{
                    '& .MuiInput-underline:before': {
                      borderBottomColor: whitelabel?.theme?.text_primary_color,
                    },
                    '& .MuiInput-underline:after': {
                      borderBottomColor: whitelabel?.theme?.text_primary_color,
                    },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                      borderBottomColor: whitelabel?.theme?.text_primary_color,
                    },
                    '& .MuiInputBase-input': {
                      color: whitelabel?.theme?.text_primary_color,
                    }
                  }}
              />
              <ErrorMessage
                className="text-danger text-sm"
                component="span"
                name="card_holder_name"
              />
            </Form.Group>
            {/* <Form.Group className="mb-3">
                <span className="form-label mb-1">
                  CPF do titular do cartão
                </span>
                <InputMask
                  mask="999.999.999-99"
                  maskChar={null}
                  name="card_document"
                  className="form-control"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={cpf}
                >
                  {(inputProps) => (
                    <TextField {...inputProps} variant="standard" />
                  )}
                </InputMask>
                <ErrorMessage
                  className="text-danger text-sm"
                  component="span"
                  name="card_document"
                />
              </Form.Group> */}

            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <span className="form-label mb-1">Validade</span>
                  <InputMask
                    className="form-control w-100"
                    mask="99/99"
                    maskChar={null}
                    name="card_expiration_date"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.card_expiration_date}
                  >
                    {(inputProps) => (
                      <TextField 
                        {...inputProps} 
                        type="tel"
                        inputProps={{
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          autoComplete: "cc-csc",
                        }}
                        variant="standard"
                          sx={{
                            '& .MuiInput-underline:before': {
                              borderBottomColor: whitelabel?.theme?.text_primary_color,
                            },
                            '& .MuiInput-underline:after': {
                              borderBottomColor: whitelabel?.theme?.text_primary_color,
                            },
                            '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                              borderBottomColor: whitelabel?.theme?.text_primary_color,
                            },
                            '& .MuiInputBase-input': {
                              color: whitelabel?.theme?.text_primary_color,
                            }
                          }}
                      />
                    )}
                  </InputMask>
                  <ErrorMessage
                    className="text-danger text-sm"
                    component="span"
                    name="card_expiration_date"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3 pb-2 border-none">
                  <span className="form-label mb-1">CVV</span>
                  <InputMask
                    mask="9999"
                    maskChar={null}
                    className="form-control"
                    name="card_cvv"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.card_cvv}
                  >
                    {(inputProps) => (
                      <TextField 
                        {...inputProps}
                        variant="standard"     
                        type="tel"
                        inputProps={{
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          autoComplete: "cc-csc",
                        }}
                        sx={{
                          '& .MuiInput-underline:before': {
                            borderBottomColor: whitelabel?.theme?.text_primary_color,
                          },
                          '& .MuiInput-underline:after': {
                            borderBottomColor: whitelabel?.theme?.text_primary_color,
                          },
                          '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                            borderBottomColor: whitelabel?.theme?.text_primary_color,
                          },
                          '& .MuiInputBase-input': {
                            color: whitelabel?.theme?.text_primary_color,
                          }
                        }}
                      />
                    )}
                  </InputMask>
                  <ErrorMessage
                    className="text-danger text-sm"
                    component="span"
                    name="card_cvv"
                  />
                </Form.Group>
              </Col>
            </Row>

            {!isMyAccountPage && (
              <div className="d-flex align-items-center gap-1">
                <Field
                  type="checkbox"
                  name="card_save"
                  id="mainCard"
                  checked={values.card_save === true}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setFieldValue("card_save", isChecked ? true : false);

                    trackClick({
                      title: isChecked ? "marcou-salvar-dados-para-compras-futuras" : "desmarcou-salvar-dados-para-compras-futuras",
                      contentType: "cadastrar-novo-cartao",
                      screenName,
                      tagId: tagIdFromLegacySuffix("08"),
                    });
                  }}
                />
                <CheckboxLabel htmlFor="mainCard" className="text-xs">
                  Salvar os dados para compras futuras
                </CheckboxLabel>
              </div>
            )}

            <div className="d-flex justify-content-center my-4">
              <button
                type="submit"
                onClick={handleSubmit}
                className="btn-default-wl font-wl-700 text-xxs p-2"
                style={{
                  width: 187,
                }}
                disabled={!isValid || !dirty || isSubmitting || Loading || !!cardValidationError || isValidatingCard}
              >
                {isSubmitting || Loading || isValidatingCard ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                ) : (
                  "ADICIONAR"
                )}
              </button>
            </div>
          </FormFormik>
        )}
      </Formik>
    </>
  );
};

FormNewCard.propTypes = {
  saveNewCard: PropTypes.func,
  onCancel: PropTypes.func,
  cards: PropTypes.array,
  isMyAccountPage: PropTypes.bool,
  Loading: PropTypes.bool,
};
